// @ts-ignore
// import {encode} from 'flexsearch/dist/lang/latin/extra.min.js';
import {ref, Ref, computed, ComputedRef} from 'vue';
import {Document} from 'flexsearch';
import {NodeContext} from '../../../@polygonjs/polygonjs/src/engine/poly/NodeContext';
import {DocumentPage} from '../documents/DocumentPage';
import {DocumentNode} from '../documents/DocumentNode';
import {DocumentApi} from '../documents/DocumentApi';
import {DocumentExpression} from '../documents/DocumentExpression';
import {DOCUMENT_NODES_NOT_FETCHED} from '../documents/DocumentNodeNotFetched';
import {DOCS_PAGES, PageData} from '../pages/Pages';
import {docsNode, docsExpression, docsRoute} from '../../routes';
import {ApiName, API_NAMES, docsApiRoute} from '../api/Common';
import {Poly} from '../../../@polygonjs/polygonjs/src/engine/Poly';
import {StoreController} from '../../editor/store/controllers/StoreController';
import {AppConfig} from '../../config/AppConfig';
import {versions} from '../../editor/versions';
enum SearchField {
	TITLE = 'title',
	CONTENT = 'content',
}
type PageDataCallback = (pageData: PageData) => void;
export interface SearchDocument {
	id: number;
	title: string;
	content: string;
	url: string;
}
const RESULTS_COUNT_LIMIT = 10;

const IMPORT_KEYS: string[] = [
	'reg',
	'title.cfg',
	'title.map',
	'title.ctx',
	'content.cfg',
	'content.map',
	'content.ctx',
];
const DOCUMENTS_BY_ID_KEY = 'documentsbyid';
const IMPORT_KEYS_WITH_UNDEFINED: string[] = ['tag', 'store'];

type ExportCallback = (key: string, content: string) => void;

export class SearchIndexControllerClass {
	private static _instance: SearchIndexControllerClass;
	static instance() {
		return (this._instance = this._instance || new SearchIndexControllerClass());
	}
	private constructor() {}
	private _index = new Document({
		// charset: 'latin:extra',
		preset: 'match',
		tokenize: 'full',
		// encode: 'extra',
		// encode: encode,
		document: {
			id: 'id',
			index: [SearchField.TITLE, SearchField.CONTENT],
		},
	});
	private _documentById: Map<number, SearchDocument> = new Map();
	private _indexCreationInProgress: Ref<boolean> = ref(false);
	private _indexCreated: Ref<boolean> = ref(false);
	// private _query = ref('')

	async prepareIndex() {
		if (0) {
			await this._createIndex_();
		} else {
			await this._import();
		}
	}

	async _createIndex_() {
		if (this._indexCreationInProgress.value) {
			return;
		}
		await AppConfig.register({sceneName: null});
		this._indexCreationInProgress.value = true;
		this._documentById.clear();
		// console.log(FlexSearch);
		// const index = new Index();
		// const document = new Document({});
		// const worker = new Worker();

		// index.add(id, text);

		let id = 0;
		const promises: Promise<void>[] = [];

		const indexExpressionDocument = async (expressionName: string) => {
			const fetchResult = await DocumentExpression.fetch({expressionName});
			if (!fetchResult) {
				return;
			}
			const doc: SearchDocument = {
				id: id,
				title: `${expressionName}`,
				content: fetchResult.text,
				url: docsExpression(expressionName),
			};
			this._index.add(doc.id, {
				title: doc.title,
				content: doc.content,
			});
			this._documentById.set(id, doc);
			id++;
		};
		const indexNodeDocument = async (context: NodeContext, type: string) => {
			const fetchResult = await DocumentNode.fetch({context, type});
			if (!fetchResult) {
				return;
			}
			const doc: SearchDocument = {
				id: id,
				title: `${context}/${type}`,
				content: fetchResult.text,
				url: docsNode(context, type),
			};
			this._index.add(doc.id, {
				title: doc.title,
				content: doc.content,
			});
			this._documentById.set(id, doc);
			id++;
		};
		const indexApiDocument = async (apiName: ApiName) => {
			const fetchResult = await DocumentApi.fetch({apiName});
			if (!fetchResult) {
				return;
			}
			const doc: SearchDocument = {
				id: id,
				title: `API / ${apiName}`,
				content: fetchResult.text,
				url: docsApiRoute(apiName),
			};
			this._index.add(doc.id, {
				title: doc.title,
				content: doc.content,
			});
			this._documentById.set(id, doc);
			id++;
		};
		const indexPageDocument = async (pageData: PageData) => {
			const fetchResult = await DocumentPage.fetch({route: pageData.route});
			if (!fetchResult) {
				return;
			}
			const doc: SearchDocument = {
				id: id,
				title: `${pageData.name}`,
				content: fetchResult.text,
				url: docsRoute(pageData.route),
			};
			this._index.add(doc.id, {
				title: doc.title,
				content: doc.content,
			});
			this._documentById.set(id, doc);
			id++;
		};
		Poly.expressionsRegister.availableMethods().forEach((expressionName) => {
			promises.push(indexExpressionDocument(expressionName));
		});
		Poly.nodesRegister.map().forEach((contextMap, context) => {
			const notFetched = DOCUMENT_NODES_NOT_FETCHED[context];
			contextMap.forEach((_, nodeType) => {
				if (notFetched.includes(nodeType.toLowerCase())) {
					return;
				}
				promises.push(indexNodeDocument(context, nodeType));
			});
		});
		function traverseDocPage(docPage: PageData, callback: PageDataCallback) {
			callback(docPage);
			if (docPage.children) {
				for (let child of docPage.children) {
					callback(child);
				}
			}
		}
		for (const apiName of API_NAMES) {
			promises.push(indexApiDocument(apiName));
		}
		for (const docPage of DOCS_PAGES) {
			traverseDocPage(docPage, (child) => {
				promises.push(indexPageDocument(child));
			});
		}

		const indexStartTime = performance.now();
		await Promise.all(promises);
		const totalTime = performance.now() - indexStartTime;
		console.log(`indexed ${promises.length} documents in ${totalTime.toFixed(4)}ms`);

		this._indexCreated.value = true;
	}
	export(callback: ExportCallback) {
		// store
		// const storedData: Record<string, unknown> = {};
		this._index.export(function (key, data) {
			// console.log(key, (data as any)?.length);
			// console.log(data);
			// storedData[key] = data;
			callback(`${key}`, data as string);
		});
		// make sure to include this._documentById
		const documentsById: SearchDocument[] = [];
		this._documentById.forEach((doc, id) => {
			const simplifiedDoc: SearchDocument = {
				...doc,
			};
			simplifiedDoc.content = doc.content.split('\n')[0];
			documentsById[id] = simplifiedDoc;
		});
		callback(DOCUMENTS_BY_ID_KEY, JSON.stringify(documentsById));
		// console.log(DOCUMENTS_BY_ID_KEY);
		// console.log(JSON.stringify(documentsById));
	}
	private async _import() {
		this._indexCreated.value = false;
		const documentById = this._documentById;
		const index = this._index;
		const timestamp = versions().editor;
		function _url(key: string, ext = 'txt') {
			const searchIndexElement = document.getElementById('search-index-config');
			// By default, the search index will be fetched from this url.
			// This is the case for:
			// - the local app
			// - the remote app WHEN it is using the last version
			// When it is not using the last version, it will fetch it from s3
			let urlPrefix = `/editor/docs/search`;
			if (searchIndexElement) {
				console.log('searchIndexElement.dataset', searchIndexElement.dataset);
				const urlPrefixOverride = searchIndexElement.dataset['indexprefix'];
				if (urlPrefixOverride) {
					urlPrefix = urlPrefixOverride;
				}
			}
			return `${urlPrefix}/${key}.${ext}?t=${timestamp}`;
		}
		async function fetchKey(key: string) {
			const response = await fetch(_url(key));
			const text = await response.text();
			index.import(key, text);
		}

		async function fetchDocumentsById() {
			const response = await fetch(_url(DOCUMENTS_BY_ID_KEY, 'json'));
			const json = (await response.json()) as SearchDocument[];
			documentById.clear();
			for (let jsonDoc of json) {
				documentById.set(jsonDoc.id, jsonDoc);
			}
		}
		const promises: Promise<void>[] = [];
		for (const key of IMPORT_KEYS) {
			promises.push(fetchKey(key));
		}
		promises.push(fetchDocumentsById());
		const indexStartTime = performance.now();
		await Promise.all(promises);

		for (const key of IMPORT_KEYS_WITH_UNDEFINED) {
			index.import(key, undefined);
		}

		const totalTime = performance.now() - indexStartTime;
		console.log(`loaded cached index in ${totalTime.toFixed(4)}ms`);
		this._indexCreated.value = true;
	}
	public loading = computed(() => this._indexCreated.value == false);
	public searchResults: ComputedRef<SearchDocument[]> = computed(() => {
		if (!this._indexCreated.value) {
			return [];
		} else {
			const query = StoreController.editor.docs.searchQuery.value;
			return this._getRearch(query);
		}
	});
	private _getRearch(query: string): SearchDocument[] {
		const results = this._index.search(query, RESULTS_COUNT_LIMIT);
		const ids: number[] = [];

		// 1. check the title results first
		const titleResults = results.find((result) => result.field == SearchField.TITLE);
		if (titleResults) {
			ids.push(...(titleResults.result as number[]));
		}
		// 2. then check the content results
		const contentResults = results.find((result) => result.field == SearchField.CONTENT);
		if (contentResults) {
			for (let id of contentResults.result as number[]) {
				if (!ids.includes(id) && ids.length < RESULTS_COUNT_LIMIT) {
					ids.push(id);
				}
			}
		}
		const documents: SearchDocument[] = [];
		for (let id of ids) {
			const doc = this._documentById.get(id);
			if (doc) {
				documents.push(doc);
			}
		}
		return documents;
	}
}
export const SearchIndexController = SearchIndexControllerClass.instance();
